import { render } from "./LogoutOtherBrowserSessionsForm.vue?vue&type=template&id=4e5b9d61"
import script from "./LogoutOtherBrowserSessionsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoutOtherBrowserSessionsForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Profile/Partials/LogoutOtherBrowserSessionsForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e5b9d61"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e5b9d61', __exports__)) {
    api.reload('4e5b9d61', __exports__)
  }
  
  module.hot.accept("./LogoutOtherBrowserSessionsForm.vue?vue&type=template&id=4e5b9d61", () => {
    api.rerender('4e5b9d61', render)
  })

}


export default __exports__